import React from 'react';
import './style.css';

export const FundingNotice = () => {
    return (
        <div className="funding-notice">
            <div className="funding-notice-content">
                <div className="funding-notice-logos">
                    <a
                        className="funding-notice-logo-link funding-notice-logo-link-bmbfsfj"
                        href="https://www.bmbf.de/bmbf/de/home/home_node.html"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            className="funding-notice-logo funding-notice-logo-bmbfsfj"
                            alt="Gefördert vom Bundesministerium für Bildung, Familie, Senioren, Frauen und Jugend (BMBFSFJ)"
                            src="/img/BMBFSFJ_gefoerdert_vom_deutsch_Web.svg"
                        />
                    </a>

                    <a
                        className="funding-notice-logo-link funding-notice-logo-link-eu"
                        href="https://next-generation-eu.europa.eu/index_de"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            className="funding-notice-logo funding-notice-logo-eu"
                            alt="Finanziert von der Europäischen Union – NextGenerationEU"
                            src="/img/de-finanziert-von-der-europn-ischen-union-pos-1.png"
                        />
                    </a>
                </div>

                <p className="funding-notice-text">
                    Finanziert durch die Europäische Union - NextGenerationEU
                    und gefördert durch das Bundesministerium für Bildung,
                    Frauen, Senioren, Familie und Jugend (BMBFSFJ) unter dem
                    Förderkennzeichen 01JA23T01C. Die geäußerten Ansichten und
                    Meinungen sind ausschließlich die des Autors/der Autorin
                    und spiegeln nicht unbedingt die Ansichten der
                    Europäischen Union, Europäischen Kommission oder des
                    Bundesministeriums für Bildung, Frauen, Senioren, Familie
                    und Jugend (BMBFSFJ) wider. Weder die Europäische Union,
                    die Europäische Kommission noch das Bundesministerium für
                    Bildung, Frauen, Senioren, Familie und Jugend (BMBFSFJ)
                    können für sie verantwortlich gemacht werden.
                </p>
            </div>
        </div>
    );
};
